module.exports = __webpack_public_path__ + "img/3-2.93662ef3.svg";